var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { BackrsIcon } from './BackrsIcon';
import { appStrings } from '../assets/appStrings';
var TOUR_STRINGS = appStrings.modules.tour;
export var HideTourExpandableButton = function (_a) {
    var onHideTourClick = _a.onHideTourClick, isTourActive = _a.isTourActive, onShowTourClick = _a.onShowTourClick, containerSx = _a.containerSx;
    var _b = useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    return (_jsxs(Box, { onClick: isExpanded ? undefined : function () { return setIsExpanded(function (prev) { return !prev; }); }, sx: __assign(__assign(__assign({}, containerStyle), { borderRadius: isExpanded ? '24px' : '100%', cursor: isExpanded ? 'default' : 'pointer' }), containerSx), id: "hide-tour-expandable-button", children: [_jsx(BackrsIcon, { name: "IconBusOff", alt: isTourActive ? TOUR_STRINGS.leaveTour : TOUR_STRINGS.showTour, height: 24, width: 24 }), isExpanded && (_jsxs(_Fragment, { children: [_jsx(Typography, { sx: textStyles, onClick: function () {
                            setIsExpanded(false);
                            if (isTourActive) {
                                onHideTourClick();
                                return;
                            }
                            onShowTourClick();
                        }, children: isTourActive ? TOUR_STRINGS.leaveTour : TOUR_STRINGS.showTour }), _jsx(Box, { onClick: function () { return setIsExpanded(false); }, sx: closeIconStyle, children: _jsx(BackrsIcon, { name: "IconClose", alt: "close", height: 20, width: 20 }) })] }))] }));
};
var containerStyle = {
    position: 'fixed',
    right: '16px',
    top: '16px',
    bgcolor: 'black',
    zIndex: 100000000000,
    display: 'flex',
    justifyContent: 'space-between',
    gap: 2,
    alignItems: 'center',
    padding: '12px',
};
var closeIconStyle = {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
var textStyles = {
    cursor: 'pointer',
    color: 'white',
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: 1,
};
